import React from 'react'
import AppBar from 'material-ui-legacy/AppBar'
import Drawer from 'material-ui-legacy/Drawer'
import IconButton from 'material-ui-legacy/IconButton'
import NavigationClose from 'material-ui-legacy/svg-icons/navigation/close'

const AppDrawer = (props) => (
  <Drawer
    open={props.open}
    docked={false}
    onRequestChange={props.closeCallback}>
    <AppBar
      title="Navigation"
      iconElementLeft={<IconButton><NavigationClose /></IconButton>}
      onLeftIconButtonClick={props.closeCallback}
    />
    {props.children}
  </Drawer>
)

export default AppDrawer



// WEBPACK FOOTER //
// ./src/components/AppDrawer.jsx